import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import axios from 'axios';
import config from '../../../config/config';
import {NotificationManager} from 'react-notifications';
import SupporterApi from '../../../apis/SupporterApi';

class SupporterActionsBlock extends Component {

    constructor(props) {
        super(props);

        this.handleResetPasswordAndSendToken = this.handleResetPasswordAndSendToken.bind(this);
        this.handleUpdateShiftsToConfirmAndSendMail = this.handleUpdateShiftsToConfirmAndSendMail.bind(this);
        this.handlePrintShiftInfos = this.handlePrintShiftInfos.bind(this);
    }

    handleResetPasswordAndSendToken() {
        const {t, supporterDetails} = this.props;

        swal({
            title: t('supporter.resetPasswordAndSendToken.delete.really.title'),
            text: t('supporter.resetPasswordAndSendToken.really.text', {
                firstname: supporterDetails.firstname,
                lastname: supporterDetails.lastname
            }),
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((reallyDo) => {
            if (reallyDo) {
                axios(config.server.endpoint + 'backend/supporter/resetPasswordAndSetToken/' + supporterDetails.id, {
                    method: 'put'
                }).then((response) => {
                    if (response.status === 200) {
                        NotificationManager.success(t('supporterScreen.supporterActions.resetPasswordAndSendToken.success'), t('default.notification.action.success'), 5000);
                    } else {
                        NotificationManager.error(t('supporterScreen.supporterActions.resetPasswordAndSendToken.error'), t('default.notification.action.error'), 5000);
                    }
                })
            }
        })
    }

    handleUpdateShiftsToConfirmAndSendMail() {
        const {t, supporterProject} = this.props;

        axios(config.server.endpoint + 'backend/supporter/project/updateShiftsToConfirmAndSendMail/' + supporterProject.id, {
            method: 'put'
        }).then((response) => {
            if (response.status === 200) {
                NotificationManager.success(t('supporterScreen.supporterActions.updateShiftsToConfirmAndSendMail.success'), t('default.notification.action.success'), 5000);
            } else {
                NotificationManager.error(t('supporterScreen.supporterActions.updateShiftsToConfirmAndSendMail.error'), t('default.notification.action.error'), 5000);
            }
        })
    }

    handlePrintShiftInfos() {
        const {supporterDetails, printer} = this.props;
        const selectedPrinter = printer && printer.selectedPrinter;

        if (!selectedPrinter) {
            NotificationManager.error('Bitte zuerst einen Drucker auswählen', 'Druckauftrag fehlgeschlagen', 5000);
            return;
        }

        SupporterApi.printSupporterProjectShiftInfo(supporterDetails.id, selectedPrinter.identifier)
            .then((response) => {
                if (response.status === 200 && response.data.success) {
                    NotificationManager.success(`Drucker: ${selectedPrinter.comment}`, 'Druckauftrag erfolgreich', 10000);
                } else {
                    NotificationManager.error('Druckauftrag konnte nicht erstellt werden', 'Druckauftrag fehlgeschlagen', 5000);
                }
            })
            .catch(() => {
                NotificationManager.error('Druckauftrag konnte nicht erstellt werden', 'Druckauftrag fehlgeschlagen', 5000);
            });
    }

    render() {
        const {t, externalCrew, printer} = this.props;
        const selectedPrinter = printer && printer.selectedPrinter;

        return (
            <div className="ibox SupporterActionsBlock">
                <div className="ibox-title">
                    <h5>{t('supporterScreen.supporterActions.title')}</h5>
                </div>
                <div className="ibox-content">
                    <button className="btn btn-default btn-block" onClick={this.handleResetPasswordAndSendToken}>
                        <i className="fa fa-key m-r-sm"/>
                        {t('supporterScreen.supporterActions.resetPasswordAndSendToken.title')}
                    </button>
                    {!externalCrew && (
                        <button className="btn btn-default btn-block" onClick={this.handleUpdateShiftsToConfirmAndSendMail}>
                            <i className="fa fa-envelope m-r-sm"/>
                            {t('supporterScreen.supporterActions.handleUpdateShiftsToConfirmAndSendMail.title')}
                        </button>
                    )}
                    {!externalCrew && (
                        <button className="btn btn-default btn-block" onClick={this.handlePrintShiftInfos} disabled={!selectedPrinter}>
                            <i className="fa fa-print m-r-sm"/>
                            {t('supporterProject.printShiftInfos')}
                        </button>
                    )}
                </div>
            </div>
        )
    }
}

export default translate()(SupporterActionsBlock);
